import classNames from 'classnames';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './EmptyResult.less';

interface OwnProps {}

type Props = OwnProps;

export const EmptyResult: React.FC<Props> = () => {
  return (
    <div className={styles.dlEmptyResult} data-name={'emptyResult'}>
      <div
        className={styles.dlEmptyResultObject}
        data-name={'emptyResultObject'}
      >
        <span
          className={styles.dlEmptyResultIconContainer}
          data-name={'emptyResultIconContainer'}
        >
          <span
            className={classNames({
              'fas fa-times': true,
              [styles.dlEmptyResultCrossIcon]: true,
            })}
            data-name={'emptyResultCrossIcon'}
          />
          <div
            className={classNames({
              'fas fa-search': true,
              [styles.dlEmptyResultIcon]: true,
            })}
            data-name={'emptyResultIcon'}
          />
        </span>
        <div className={styles.dlEmptyResultText} data-name={'emptyResultText'}>
          <FormattedMessage
            id={'common.emptyResult'}
            defaultMessage={'There are no results that match your search.'}
            description={'text displayed in container if there is no content'}
          />
        </div>
      </div>
    </div>
  );
};

EmptyResult.displayName = 'EmptyResult';
